import { useEffect, useRef, useState } from "react";
import { useInView } from "framer-motion";
import { ShieldCheck, Smiley, Buildings, UsersThree, Headset, Tag } from "@phosphor-icons/react";
import { Reveal } from "@/components/Reveal";

const ITEMS = [
  { icon: ShieldCheck, end: 100, suffix: "%", label: "Money Safe" },
  { icon: Smiley, end: 12, suffix: "K+", label: "Happy Clients" },
  { icon: Buildings, end: 500, suffix: "+", label: "Hotels & Transport" },
  { icon: UsersThree, end: 25, suffix: "+", label: "Ground Experts" },
  { icon: Headset, text: "24/7", label: "Support" },
  { icon: Tag, text: "Unlimited", label: "Deals" },
];

function CountUp({ end, suffix }) {
  const ref = useRef(null);
  const inView = useInView(ref, { once: true });
  const [val, setVal] = useState(0);

  useEffect(() => {
    if (!inView) return;
    const start = Date.now();
    const t = setInterval(() => {
      const p = Math.min(1, (Date.now() - start) / 1400);
      setVal(Math.floor(end * (1 - Math.pow(1 - p, 3))));
      if (p === 1) clearInterval(t);
    }, 30);
    return () => clearInterval(t);
  }, [inView, end]);

  return <span ref={ref}>{val.toLocaleString("en-IN")}{suffix}</span>;
}

export default function WhyChooseUs() {
  return (
    <section className="bg-brand-sand py-20 md:py-24" data-testid="why-choose-us">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <Reveal className="text-center mb-14">
          <h2 className="text-4xl sm:text-5xl font-heading font-semibold leading-tight">
            <span className="text-brand-orange">Why</span> <span className="text-brand-navy">Choose Us</span>
          </h2>
          <p className="mt-3 text-[#6b6a8a] font-body">Trusted by thousands of travellers across India</p>
        </Reveal>
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-5">
          {ITEMS.map((it, i) => (
            <Reveal key={it.label} delay={i * 0.06}>
              <div className="flex flex-col items-center text-center rounded-2xl bg-white p-6 shadow-[0_8px_30px_rgba(46,42,128,0.08)] transition-transform hover:-translate-y-1" data-testid={`counter-${i}`}>
                <span className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-brand-teal/10 text-brand-teal">
                  <it.icon size={28} weight="duotone" />
                </span>
                <p className="font-accent text-2xl md:text-3xl font-extrabold text-brand-navy">
                  {it.text ? it.text : <CountUp end={it.end} suffix={it.suffix} />}
                </p>
                <p className="mt-1 text-xs uppercase tracking-wider text-[#8B89A4] font-body">{it.label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
